import React, { useEffect, useState } from "react";
import {
  FaTrash,
  FaInfoCircle,
  FaUpload,
  FaCalculator,
  FaShieldAlt,
} from "react-icons/fa";
import { FiShield } from "react-icons/fi";
import { showToast } from "../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { hitUploadMedia } from "../../../Redux/Common/UploadMediaSlice";
import { hitSubmitBidApi } from "../../../Redux/Professional/SubmitBidSlice";
import { useNavigate } from "react-router-dom";
import { hitGetBoostBidProfessionalApi } from "../../../Redux/Professional/GetBoostBidsSlice";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { FaStar, FaCheckCircle } from "react-icons/fa";
import { useSelector } from "react-redux";
import { timeAgo } from "../../../Helper/CommonFunctions";
import { all } from "axios";
import BoostYourBid from "../../../assets/img/Boost Your Bid.svg";
import boostBtn from "../../../assets/img/Boost btn.svg";
import firstPlace from "../../../assets/img/first place.svg";
import secondPlace from "../../../assets/img/secoundPlace.svg";
import thirdPlace from "../../../assets/img/thirdPlace.svg";
import download from "../../../assets/img/download upload icon.svg";
import Loader from "../../Loader/Loader"; // adjust the path

const SubmitBidView = ({ jobData }) => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [bid, setBid] = useState(1);
  const [loading, setLoading] = useState(false);
  const [boostBidPoints, setBoostBidPoints] = useState(0);
  const [credits, setCredits] = useState(75);



  const [discount, setDiscount] = useState(0);
  const [tax, setTax] = useState(0);

  const [discount1, setDiscount1] = useState(0);
  const [tax1, setTax1] = useState(0);

  const [discount2, setDiscount2] = useState(0);
  const [tax2, setTax2] = useState(0);

  const [customerMessage, setCustomerMessage] = useState("");
  const [customerMessage1, setCustomerMessage1] = useState("");
  const [customerMessage2, setCustomerMessage2] = useState("");
  const [requiredDeposit, setRequiredDeposit] = useState(0);
  const [requiredDeposit1, setRequiredDeposit1] = useState(0);
  const [requiredDeposit2, setRequiredDeposit2] = useState(0);

  const [bidExpiry, setBidExpiry] = useState("1 year");
  const [financing, setFinancing] = useState(0);
  const [financing1, setFinancing1] = useState(0);
  const [financing2, setFinancing2] = useState(0);
  const [priceType, setPriceType] = useState("estimated");
  const [priceType1, setPriceType1] = useState("estimated");
  const [priceType2, setPriceType2] = useState("estimated");

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedFiles1, setUploadedFiles1] = useState([]);
  const [uploadedFiles2, setUploadedFiles2] = useState([]);

  const [isDisabled, setIsDisabled] = useState(false);

  const [selectedIndex, setSelectedIndex] = useState(0);

  const [deletedIndexes, setDeletedIndexes] = useState([]);

  const [images, setImages] = useState([
    // "https://simplerenovate.s3.us-east-1.amazonaws.com/1763563807127IMG_20251119_201937.jpg",
    // "https://simplerenovate.s3.us-east-1.amazonaws.com/1756185746134promo_image_0.jpeg",
    // "https://images.unsplash.com/photo-1560807707-8cc77767d783?w=400",
  ]);


  const [wantToBoostBid, setWantToBoostBid] = useState(false);

  const [finalMediaToSend, setFinalMediaToSend] = useState([]);
  const [finalMediaToSend1, setFinalMediaToSend1] = useState([]);
  const [finalMediaToSend2, setFinalMediaToSend2] = useState([]);

  const [boostBidsData, setBoostBidsData] = useState([]);

  useEffect(() => {
    if (!localStorage.getItem("professionalToken")) {
      // navigation("/professional/login");
    } else {
      dispatch(hitGetBoostBidProfessionalApi(jobData._id));
    }
  }, []);

  const responseBoostBidsData = useSelector(
    (state) => state.getBoostBidProfessionalReducer
  );

  useEffect(() => {
    if (responseBoostBidsData && responseBoostBidsData.data) {
      if (responseBoostBidsData.data.status === true) {
        setBoostBidsData(responseBoostBidsData.data.data);
        //console.log("Boost Bids Data:", responseBoostBidsData.data.data);
        if (boostBidsData.length > 0) {
          setBid(boostBidsData[0].amount + 1);
        }
      } else {
        showToast(responseBoostBidsData.data.message, "error");
      }
    }
  }, [responseBoostBidsData]);

  const handleBoostBid = () => {
    //console.log("handleBoostBid calling", bid);
    setWantToBoostBid(true);
    setBoostBidPoints(bid);
    const newBoostDataArray = [...boostBidsData]; // create a shallow copy
    // Remove any object with createdAt == 1
    const filteredData = newBoostDataArray.filter(
      (item) => item.createdAt !== 1
    );
    filteredData.push({ amount: bid, createdAt: 1, rank: 1 });
    //console.log("After Push boostBidsData", filteredData);
    const newDataSorted = filteredData.sort((a, b) => b.amount - a.amount);
    //console.log("After Sort newDataSorted", newDataSorted);
    // Update the ranks of each place
    // Update ranks by creating new objects with the new rank
    const updatedDataWithRanks = newDataSorted.map((entry, index) => ({
      ...entry, // Spread the old data
      rank: index + 1, // Update the rank
    }));
    //console.log("After Rank newDataSorted", updatedDataWithRanks);
    setBoostBidsData(updatedDataWithRanks);
  };

  const handleRemoveBoostBid = (index) => {
    //console.log("removeBoostBid calling");
    setWantToBoostBid(false);
    setBid(0);
    setBoostBidPoints(0);
    const newBoostDataArray = [...boostBidsData]; // create a shallow copy
    newBoostDataArray.splice(index, 1); // remove the item at the specified index
    //console.log("After Splice newBoostDataArray", newBoostDataArray);
    const newDataSorted = newBoostDataArray.sort((a, b) => b.amount - a.amount);
    //console.log("After Sort newDataSorted", newDataSorted);
    // Update the ranks of each place
    const updatedDataWithRanks = newDataSorted.map((entry, index) => ({
      ...entry, // Spread the old data
      rank: index + 1, // Update the rank
    }));
    //console.log("After Rank newDataSorted", updatedDataWithRanks);
    setBoostBidsData(updatedDataWithRanks);
    if (updatedDataWithRanks.length > 0) {
      setBid(updatedDataWithRanks[0].amount + 1);
    } else {
      setBid(1);
    }
  };


  //  optionType: { type: Number, default: 1 }, // 1- good, 2- better, 3- best
  //     image: { type: String, default: "" },
  //     optionPrice: { type: String, default: "0" },
  //     subTotal: { type: String, default: "0" },
  //     discountPercentage: { type: Number, default: 0 },
  //     discountAmount: { type: String, default: "0" },
  //     taxAmount: { type: String, default: "0" },
  //     // new parameters
  //     message: { type: String, default: "" },
  //     requiredDeposit: { type: String, default: "" },
  //     financing: { type: String, default: "" },
  //     priceType: { type: Number, default: 1 }, // 1- guranntee, 2- estimate
  //     media: { type: Array, default: [] },
  //     finalAmount: { type: String, default: "0" },
  //     items: [
  //       {
  //         image: { type: String, default: "" },
  //         product: { type: String, default: "" },
  //         description: { type: String, default: "" },
  //         quantity: { type: Number, default: 1 },
  //         unitPrice: { type: String, default: "" },
  //         price: { type: String, default: "" },
  //       },
  //     ],

  const [lineItems, setLineItems] = useState([
    {
      id: 1,
      product: "",
      description: "",
      quantity: 1,
      unitPrice: 0,
      price: 0,
    },
  ]);

  const [lineItems1, setLineItems1] = useState([
    {
      id: 1,
      product: "",
      description: "",
      quantity: 1,
      unitPrice: 0,
      price: 0,
    },
  ]);

  const [lineItems2, setLineItems2] = useState([
    {
      id: 1,
      product: "",
      description: "",
      quantity: 1,
      unitPrice: 0,
      price: 0,
    },
  ]);

  const handleIncrease = () => {
    setBid(bid + 1);
  };

  const handleDecrease = () => {
    if (bid > 0) {
      setBid(bid - 1);
    }
  };

  // Calculate totals
  const calculateSubTotal = () => {
    return lineItems.reduce((sum, item) => {
      return sum + item.quantity * item.unitPrice;
    }, 0);
  };

  const subTotal = calculateSubTotal();
  const discountAmount = (subTotal * discount) / 100;
  const taxAmount = (subTotal * tax) / 100;
  const finalTotal = subTotal - discountAmount + taxAmount;

  // Calculate totals
  const calculateSubTotal1 = () => {
    return lineItems1.reduce((sum, item) => {
      return sum + item.quantity * item.unitPrice;
    }, 0);
  };

  const subTotal1 = calculateSubTotal1();
  const discountAmount1 = (subTotal1 * discount1) / 100;
  const taxAmount1 = (subTotal1 * tax1) / 100;
  const finalTotal1 = subTotal1 - discountAmount1 + taxAmount1;

  // Calculate totals
  const calculateSubTotal2 = () => {
    return lineItems2.reduce((sum, item) => {
      return sum + item.quantity * item.unitPrice;
    }, 0);
  };

  const subTotal2 = calculateSubTotal2();
  const discountAmount2 = (subTotal2 * discount2) / 100;
  const taxAmount2 = (subTotal2 * tax2) / 100;
  const finalTotal2 = subTotal2 - discountAmount2 + taxAmount2;

  // Add new line item
  const addLineItem = () => {
    const newId = Math.max(...lineItems.map((item) => item.id), 0) + 1;
    setLineItems([
      ...lineItems,
      {
        id: newId,
        product: "",
        description: "",
        quantity: 1,
        price: 0,
        unitPrice: 0,
      },
    ]);
  };

  // Add new line item
  const addLineItem1 = () => {
    const newId = Math.max(...lineItems1.map((item) => item.id), 0) + 1;
    setLineItems1([
      ...lineItems1,
      {
        id: newId,
        product: "",
        description: "",
        quantity: 1,
        price: 0,
        unitPrice: 0,
      },
    ]);
  };

  // Add new line item
  const addLineItem2 = () => {
    const newId = Math.max(...lineItems2.map((item) => item.id), 0) + 1;
    setLineItems2([
      ...lineItems2,
      {
        id: newId,
        product: "",
        description: "",
        quantity: 1,
        price: 0,
        unitPrice: 0,
      },
    ]);
  };

  // Delete line item
  const deleteLineItem = (id) => {
    setLineItems(lineItems.filter((item) => item.id !== id));
  };

  const deleteLineItem1 = (id) => {
    setLineItems1(lineItems1.filter((item) => item.id !== id));
  };

  const deleteLineItem2 = (id) => {
    setLineItems2(lineItems2.filter((item) => item.id !== id));
  };


  const updateLineItem = (id, field, value) => {
    //console.log("updateLineItem calling", id, field, value);
    //console.log("Previous lineItems", lineItems);
    let internalLineItems = [...lineItems];
    let getIndex = internalLineItems.findIndex((item) => item.id == id);
    //console.log("getIndex", getIndex);
    if (getIndex !== -1) {
      internalLineItems[getIndex] = {
        ...internalLineItems[getIndex],
        [field]:
          field !== "product" && field !== "description"
            ? parseFloat(value) || 0
            : value,
      };

      internalLineItems[getIndex].price = parseFloat(
        internalLineItems[getIndex].quantity *
        internalLineItems[getIndex].unitPrice
      );
      //console.log("Updated internalLineItems", internalLineItems);
      setLineItems(internalLineItems);
    }
  };

  const updateLineItem1 = (id, field, value) => {
    let internalLineItems1 = [...lineItems1];
    let getIndex = internalLineItems1.findIndex((item) => item.id == id);
    if (getIndex !== -1) {
      internalLineItems1[getIndex] = {
        ...internalLineItems1[getIndex],
        [field]:
          field !== "product" && field !== "description"
            ? parseFloat(value) || 0
            : value,
      };
      internalLineItems1[getIndex].price = parseFloat(
        internalLineItems1[getIndex].quantity *
        internalLineItems1[getIndex].unitPrice
      );
      //console.log("Updated internalLineItems1", internalLineItems1);
      setLineItems1(internalLineItems1);
    }
  };

  const updateLineItem2 = (id, field, value) => {
    let internalLineItems2 = [...lineItems2];
    let getIndex = internalLineItems2.findIndex((item) => item.id == id);
    if (getIndex !== -1) {
      internalLineItems2[getIndex] = {
        ...internalLineItems2[getIndex],
        [field]:
          field !== "product" && field !== "description"
            ? parseFloat(value) || 0
            : value,
      };
      internalLineItems2[getIndex].price = parseFloat(
        internalLineItems2[getIndex].quantity *
        internalLineItems2[getIndex].unitPrice
      );

      setLineItems2(internalLineItems2);
    }
  };


  // Add this handler near your other handlers
  const handleImageUpload = (event, idx) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImages((prev) => {
          const newImages = [...prev];
          newImages[idx] = e.target.result;
          return newImages;
        });
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle file selection
  const handleFileUpload = (event) => {
    //console.log("handleFileUpload calling");
    const files = Array.from(event.target.files);
    setUploadedFiles([...uploadedFiles, ...files]);
  };

  const handleRemoveFile = (index) => {
    //console.log("handleRemoveFile calling", index);
    setUploadedFiles(uploadedFiles.filter((_, i) => i !== index));
  };
  // Handle file selection
  const handleFileUpload1 = (event) => {
    //console.log("handleFileUpload calling");
    const files = Array.from(event.target.files);
    setUploadedFiles1([...uploadedFiles1, ...files]);
  };

  const handleRemoveFile1 = (index) => {
    //console.log("handleRemoveFile calling", index);
    setUploadedFiles1(uploadedFiles1.filter((_, i) => i !== index));
  };
  // Handle file selection
  const handleFileUpload2 = (event) => {
    //console.log("handleFileUpload calling");
    const files = Array.from(event.target.files);
    setUploadedFiles2([...uploadedFiles2, ...files]);
  };

  const handleRemoveFile2 = (index) => {
    //console.log("handleRemoveFile calling", index);
    setUploadedFiles2(uploadedFiles2.filter((_, i) => i !== index));
  };

  // // UseEffect to trigger upload when `file` changes
  // useEffect(() => {
  //   if (uploadedFiles) {
  //     //console.log("file handl starts", uploadedFiles);
  //     uploadFile();
  //   }
  // }, [uploadedFiles]);
  // // UseEffect to trigger upload when `file` changes
  // useEffect(() => {
  //   if (uploadedFiles1) {
  //     //console.log("file handl starts", uploadedFiles);
  //     uploadFile1();
  //   }
  // }, [uploadedFiles1]);
  // // UseEffect to trigger upload when `file` changes
  // useEffect(() => {
  //   if (uploadedFiles2) {
  //     //console.log("file handl starts", uploadedFiles);
  //     uploadFile2();
  //   }
  // }, [uploadedFiles2]);

  // Function to handle file upload
  const uploadFile = async () => {
    //console.log("upload file calling");
    if (uploadedFiles.length > 0) {
      const formData = new FormData();
      uploadedFiles.forEach((file) => {
        formData.append("myfile", file);
      });
      try {
        const response = await dispatch(hitUploadMedia(formData));
        if (response.payload.status === true) {
          showToast("Media uploaded successfully", "success");
          const uploadedUrls = response.payload.data.map((item) => item.url);
          setFinalMediaToSend((prev) => [...prev, ...uploadedUrls]);
        } else {
          showToast(response.payload.message, "error");
        }
      } catch (error) {
        console.error("File upload error:", error);
      }
    }
  };
  // Function to handle file upload
  const uploadFile1 = async () => {
    //console.log("upload file calling");
    if (uploadedFiles.length > 0) {
      const formData = new FormData();
      uploadedFiles.forEach((file) => {
        formData.append("myfile", file);
      });
      try {
        const response = await dispatch(hitUploadMedia(formData));
        if (response.payload.status === true) {
          showToast("Media uploaded successfully", "success");
          const uploadedUrls = response.payload.data.map((item) => item.url);
          setFinalMediaToSend1((prev) => [...prev, ...uploadedUrls]);
        } else {
          showToast(response.payload.message, "error");
        }
      } catch (error) {
        console.error("File upload error:", error);
      }
    }
  };
  // Function to handle file upload
  const uploadFile2 = async () => {
    //console.log("upload file calling");
    if (uploadedFiles.length > 0) {
      const formData = new FormData();
      uploadedFiles.forEach((file) => {
        formData.append("myfile", file);
      });
      try {
        const response = await dispatch(hitUploadMedia(formData));
        if (response.payload.status === true) {
          showToast("Media uploaded successfully", "success");
          const uploadedUrls = response.payload.data.map((item) => item.url);
          setFinalMediaToSend2((prev) => [...prev, ...uploadedUrls]);
        } else {
          showToast(response.payload.message, "error");
        }
      } catch (error) {
        console.error("File upload error:", error);
      }
    }
  };

  const handleOptOutClick = (checked) => {
    //console.log("handleOptOutClick calling", selectedIndex, checked);
    if (checked === true) {
      if (selectedIndex === 0) {
        setDeletedIndexes((prev) => [...prev, 1, 2]);
      } else if (selectedIndex === 1) {
        setDeletedIndexes((prev) => [...prev, 0, 2]);
      } else if (selectedIndex === 2) {
        setDeletedIndexes((prev) => [...prev, 0, 1]);
      }
    }
    // in case of false return back all three options
    else {
      setDeletedIndexes([]);
    }
  };

  const removeImage = (index) => {
    //console.log("removeImage calling", index);
    //console.log("Current deletedIndexes", deletedIndexes);
    if (deletedIndexes.length == 2) {
      showToast("At least one type is required.", "error");
      return;
    } else {
      setDeletedIndexes((prev) => [...prev, index]);
      // Find next or previous selectable index
      let newSelected = null;
      // 1️⃣ Try to select the next available item
      for (let i = index + 1; i < images.length; i++) {
        if (!deletedIndexes.includes(i)) {
          newSelected = i;
          break;
        }
      }

      // 2️⃣ If no next item found, try previous ones
      if (newSelected === null) {
        for (let i = index - 1; i >= 0; i--) {
          if (!deletedIndexes.includes(i)) {
            newSelected = i;
            break;
          }
        }
      }

      // 3️⃣ Update selectedIndex
      if (newSelected !== null) {
        setSelectedIndex(newSelected);
      } else {
        setSelectedIndex(null); // nothing left
      }
    }
  };

  const handleSubmitBidWithDraft = () => {
    handleSubmitBid(1);
  };

  const handleSubmitBid = (isDraft = 0) => {
    //console.log("handleSubmitBid calling", isDraft);
    // setLoading(true);
    // Construct the bid data
    let allArrays = [];
    if (deletedIndexes.includes(1) && deletedIndexes.includes(2)) {
      allArrays.push(lineItems);
    } else if (deletedIndexes.includes(0) && deletedIndexes.includes(2)) {
      allArrays.push(lineItems1);
    } else if (deletedIndexes.includes(0) && deletedIndexes.includes(1)) {
      allArrays.push(lineItems2);
    } else if (deletedIndexes.includes(0)) {
      allArrays.push(lineItems);
      allArrays.push(lineItems1);
    } else if (deletedIndexes.includes(1)) {
      allArrays.push(lineItems);
      allArrays.push(lineItems2);
    } else if (deletedIndexes.includes(2)) {
      allArrays.push(lineItems);
      allArrays.push(lineItems1);
    } else {
      allArrays.push(lineItems);
      allArrays.push(lineItems1);
      allArrays.push(lineItems2);
    }
    //console.log("All Arrays", allArrays);

    // Condition 1: At least one array has items
    const hasAtLeastOneArrayWithItems = allArrays.some((arr) => arr.length > 0);
    if (!hasAtLeastOneArrayWithItems) {
      setLoading(false);
      showToast("At least one line item array must have items.", "error");
      return;
    }

    // Condition 2: Each non-empty array has at least one valid item
    const allValid = allArrays.every((arr) => {
      if (arr.length === 0) return true; // Skip empty arrays

      // Check if the array has at least one valid item
      return arr.some(
        (item) =>
          item.product.trim() !== "" &&
          item.description.trim() !== "" &&
          item.price > 0
      );
    });

    if (!allValid) {
      setLoading(false);
      showToast(
        "Each line item must have at least one item with product, description, and price.",
        "error"
      );
      return;
    }

    //console.log("wantToBoostBid", wantToBoostBid);

    let options = [];

    for (let i = 0; i < allArrays.length; i++) {
      if (allArrays[i] == lineItems) {
        options.push({
          items: lineItems,
          optionType: 1,
          subTotal: subTotal.toString(),
          discountAmount: discountAmount.toString(),
          taxAmount: tax.toString(),
          taxPercentage: tax,
          finalAmount: finalTotal.toString(),
          discountPercentage: discount,
          optionPrice: "",
          requiredDeposit: requiredDeposit.toString(),
          financing: financing.toString(),
          message: customerMessage,
          media: finalMediaToSend,
          priceType: priceType === "guarantee" ? 1 : 2, // 1- guranntee, 2- estimate
        });
      } else if (allArrays[i] == lineItems1) {
        options.push({
          items: lineItems1,
          optionType: 2,
          subTotal: subTotal1.toString(),
          discountAmount: discountAmount1.toString(),
          taxAmount: tax1.toString(),
          taxPercentage: tax1,
          finalAmount: finalTotal1.toString(),
          discountPercentage: discount1,
          optionPrice: "",
          requiredDeposit: requiredDeposit1.toString(),
          financing: financing1.toString(),
          message: customerMessage1,
          media: finalMediaToSend1,
          priceType: priceType1 === "guarantee" ? 1 : 2, // 1- guranntee, 2- estimate
        });
      } else if (allArrays[i] == lineItems2) {
        options.push({
          items: lineItems2,
          optionType: 3,
          subTotal: subTotal2.toString(),
          discountAmount: discountAmount2.toString(),
          taxAmount: tax2.toString(),
          taxPercentage: tax2,
          finalAmount: finalTotal2.toString(),
          discountPercentage: discount2,
          optionPrice: "",
          requiredDeposit: requiredDeposit2.toString(),
          financing: financing2.toString(),
          message: customerMessage2,
          media: finalMediaToSend2,
          priceType: priceType2 === "guarantee" ? 1 : 2, // 1- guranntee, 2- estimate
        });
      }
    }

    const bidData = {
      isEditable: 0,
      jobId: jobData._id,
      isDraft: isDraft,
      options: options,
      expireAt: bidExpiry,
      isBoosted: wantToBoostBid == true ? 1 : 0,
      boostAmount: boostBidPoints,

    };

    console.log("Submitting bid data:", bidData);
    // dispatch(hitSubmitBidApi(bidData)).then((response) => {
    //   setLoading(false);
    //   if (response.payload.status === true) {
    //     if (isDraft === 1) {
    //       showToast("Bid saved as draft successfully!", "success");
    //     } else {
    //       showToast("Bid submitted successfully!", "success");
    //     }
    //     navigation("/professional/bids", {
    //       state: { bidType: isDraft === 1 ? "draft" : "submitted" },
    //     });
    //   }
    // });

    // Dispatch the submit bid action
    // dispatch(submitBid(bidData));
  };

  const rankImages = {
    0: firstPlace,
    1: secondPlace,
    2: thirdPlace,
  };

  //loader
  if (loading) {
    return <div style={{ height: "100vh" }}><Loader /></div>;
  }

  return (
    <div className="project-details mb-4" >
      {/* Header */}
      < div className="pd-header" >
        <h3>
          <span className="highlight">Project Details</span> &gt; Bid for Job
          {` ${jobData ? jobData.jobId : ""}`}{" "}
        </h3>
      </div >

      <div className="pd-images">
        <label>
          Options{" "}
          <input
            type="checkbox"
            disabled={isDisabled}
            onChange={(e) => handleOptOutClick(e.target.checked)}
          />
          <span>Opt out</span>
        </label>
        <div className="image-grid">
          {[0, 1, 2].map((idx) =>
            !deletedIndexes.includes(idx) && (
              <div
                key={idx}
                className={`image-item ${selectedIndex === idx ? "selected" : ""}`}
                onClick={() => setSelectedIndex(idx)}
                style={{ position: 'relative' }}
              >
                {images[idx] ? (
                  <>
                    <img src={images[idx]} alt="project" />
                    <span
                      className="remove"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeImage(idx);
                      }}
                    >
                      ×
                    </span>
                  </>
                ) : (
                  <>
                    <label htmlFor={`image-upload-${idx}`} style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                      <span style={{ fontSize: 32, color: '#aaa' }}>＋</span>
                      <span style={{ fontSize: 12 }}>Upload Image</span>
                      <input
                        id={`image-upload-${idx}`}
                        type="file"
                        accept="image/*"
                        style={{ display: 'none' }}
                        onChange={(e) => handleImageUpload(e, idx)}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </label>
                  </>
                )}
                {/* Always show upload icon to allow replacing image */}
                {images[idx] && (
                  <label htmlFor={`image-upload-${idx}`} style={{ position: 'absolute', bottom: 5, right: 5, background: '#fff', borderRadius: '50%', padding: 2, cursor: 'pointer', boxShadow: '0 0 2px #aaa' }} onClick={e => e.stopPropagation()}>
                    <span style={{ fontSize: 18, color: '#007bff' }}>🖼️</span>
                    <input
                      id={`image-upload-${idx}`}
                      type="file"
                      accept="image/*"
                      style={{ display: 'none' }}
                      onChange={(e) => handleImageUpload(e, idx)}
                    />
                  </label>
                )}
              </div>
            )
          )}

        </div>
      </div>

      {/* Option good */}
      {/* Line Items */}
      {
        selectedIndex === 0 && (
          <>
            <div className="pd-line-items">
              <h6>Products/service</h6>
              {lineItems.map((item, index) => (
                <div className="line-item" key={item.id}>
                  <div className="d-flex justify-content-between align-items-center">

                    <h5>Line Item {index + 1}</h5>
                    {index > 0 && (
                      <FaTrash
                        className="delete-icon"
                        onClick={() => deleteLineItem(item.id)}
                      />
                    )}
                  </div>


                  <label>Product/service</label>
                  <input
                    type="text"
                    value={item.product}
                    onChange={(e) =>
                      updateLineItem(item.id, "product", e.target.value)
                    }
                  />

                  <label>Description</label>
                  <textarea
                    type="text"
                    value={item.description}
                    onChange={(e) =>
                      updateLineItem(item.id, "description", e.target.value)
                    }
                  />

                  <div className="line-pricing">
                    <div>
                      <label>Quantity</label>
                      <input
                        type="text"
                        value={item.quantity}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9.]/g, "");
                          // Convert to number
                          let price = parseFloat(value) || 0;
                          // Enforce max 200
                          if (price > 200) price = 200;
                          updateLineItem(item.id, "quantity", price);
                        }}
                      />
                    </div>
                    <div>
                      <label>Unit Price</label>
                      <input
                        type="text"
                        value={`$ ${item.unitPrice}`}
                        onChange={(e) => {
                          // Extract only numbers + dot
                          let value = e.target.value.replace(/[^0-9.]/g, "");
                          // Convert to number
                          let price = parseFloat(value) || 0;
                          // Enforce max 50000
                          if (price > 50000) price = 50000;
                          updateLineItem(item.id, "unitPrice", price);
                        }}
                      />
                    </div>
                    <div>
                      <label>Line Total</label>
                      <input
                        type="text"
                        value={`$${(item.quantity * item.unitPrice).toFixed(2)}`}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="add-more-section">
              <button className="add-more-btn" onClick={addLineItem}>
                <span className="plus-icon">+</span> Add More
              </button>
            </div>
            <div className="pricing-summary">
              <h4>Pricing Summary</h4>

              <div className="summary-row">
                <span className="label">Sub Total:</span>
                <span className="value">${subTotal.toFixed(2)}</span>
              </div>

              <div className="summary-row discount-row">
                <span className="label">Discount (%):</span>
                <div className="discount-input-wrapper">
                  <input
                    type="number"
                    step="0.01"
                    value={discount === 0 ? '' : discount}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value === '') {
                        setDiscount(0);
                        return;
                      }
                      if (value.includes('.')) {
                        const [intPart, decPart] = value.split('.');
                        value = intPart + '.' + decPart.slice(0, 2);
                      }
                      setDiscount(Math.min(parseFloat(value) || 0, 100));
                    }}
                    className="discount-input"
                    max="100"
                    min="0"
                  />
                  <span className="percent-symbol">%</span>
                </div>
                <span className="value discount-value">
                  -${discountAmount.toFixed(2)}
                </span>
              </div>

              <div className="summary-row discount-row">
                <span className="label">Tax (%):</span>
                <div className="discount-input-wrapper">
                  <input
                    type="number"
                    step="0.01"
                    value={tax === 0 ? '' : tax}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value === '') {
                        setTax(0);
                        return;
                      }
                      if (value.includes('.')) {
                        const [intPart, decPart] = value.split('.');
                        value = intPart + '.' + decPart.slice(0, 2);
                      }
                      setTax(Math.min(parseFloat(value) || 0, 100));
                    }}
                    className="discount-input"
                    max="100"
                    min="0"
                  />
                  <span className="percent-symbol">%</span>
                </div>
                <span className="value tax-value">
                  +${taxAmount.toFixed(2)}
                </span>
              </div>

              <div className="summary-row final-row">
                <span className="label">Final Total:</span>
                <span className="value final-value">
                  ${finalTotal.toFixed(2)}
                </span>
              </div>
            </div>

            {/* Additional Details Section */}
            <div className="additional-details">
              <h4>Additional Details</h4>

              {/* Customer Message */}
              <div className="form-group">
                <label>Customer Message</label>
                <textarea
                  className="customer-message"
                  value={customerMessage}
                  onChange={(e) => setCustomerMessage(e.target.value)}
                  rows="4"
                />
              </div>

              {/* Required Deposit and Bid Expiry */}
              <div className="two-column">
                <div className="form-group">
                  <label>Required Deposit</label>
                  <input
                    type="text"
                    value={`$ ${requiredDeposit}`}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      setRequiredDeposit(parseInt(value) || 0);
                    }}
                  />
                </div>
              </div>

              {/* Financing */}
              <div className="form-group">
                <label>Financing (optional)</label>
                <input
                  type="text"
                  value={`$${financing}/month`}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    setFinancing(parseInt(value) || 0);
                  }}
                />
              </div>

              {/* Attachments */}
              <div className="form-group attachments">
                <label>Attachments</label>
                <p className="helper-text">
                  Upload documents, images or PDFs to support your bid.
                </p>

                <div
                  className="upload-area"
                  onClick={() => document.getElementById("file-upload").click()}
                >
                  <img src={download} alt="upload icon" className="upload-icon" />
                  <p>Drop files here or click to upload</p>
                  <input
                    type="file"
                    multiple
                    accept="image/*,.pdf"
                    onChange={handleFileUpload}
                    style={{ display: "none" }}
                    id="file-upload"
                  />
                  <button
                    type="button"
                    className="choose-files-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      document.getElementById("file-upload").click();
                    }}
                  >
                    Choose Files
                  </button>
                </div>

                {uploadedFiles.length > 0 && (
                  <div className="uploaded-files">
                    {uploadedFiles.map((file, index) => (
                      <div className="file-preview" key={index}>
                        {/* If image, show thumbnail; else show file name */}
                        {file.type.startsWith("image/") ? (
                          <img
                            src={URL.createObjectURL(file)}
                            alt={file.name}
                            className="file-thumb"
                          />
                        ) : (
                          <div className="file-name">{file.name}</div>
                        )}

                        <button
                          type="button"
                          className="remove-btn"
                          onClick={() => handleRemoveFile(index)}
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Price Type Selection */}
            <div className="price-type-selection mb-3">
              <h4>Select one of the following:</h4>

              <div className="radio-group">

                <label className="radio-option">
                  <input
                    type="radio"
                    name="priceType"
                    value="estimated"
                    checked={priceType === "estimated"}
                    onChange={(e) => setPriceType(e.target.value)}
                  />
                  <FaCalculator className="price-icon calculator-icon" />
                  <span>Estimated Price</span>
                  <FaInfoCircle className="info-icon" />
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="priceType"
                    value="guaranteed"
                    checked={priceType === "guaranteed"}
                    onChange={(e) => setPriceType(e.target.value)}
                  />
                  <FiShield className="price-icon shield-icon" />
                  <span>Guaranteed Price</span>
                  <FaInfoCircle className="info-icon" />
                </label>


              </div>
            </div>





          </>
        )
      }

      {/* Option Better */}
      {/* Line Items */}
      {
        selectedIndex === 1 && (
          <>
            <div className="pd-line-items">
              <h6>Products/service</h6>
              {lineItems1.map((item, index) => (
                <div className="line-item" key={item.id}>
                  <div className="d-flex justify-content-between align-items-center">
                    <h5>Line Item {index + 1}</h5>
                    {index > 0 && (
                      <FaTrash
                        className="delete-icon"
                        onClick={() => deleteLineItem1(item.id)}
                      />
                    )}
                  </div>

                  <label>Product/service</label>
                  <input
                    type="text"
                    value={item.product}
                    onChange={(e) =>
                      updateLineItem1(item.id, "product", e.target.value)
                    }
                  />

                  <label>Description</label>
                  <textarea
                    type="text"
                    value={item.description}
                    onChange={(e) =>
                      updateLineItem1(item.id, "description", e.target.value)
                    }
                  />

                  <div className="line-pricing">
                    <div>
                      <label>Quantity</label>
                      <input
                        type="text"
                        value={item.quantity}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9.]/g, "");
                          // Convert to number
                          let price = parseFloat(value) || 0;

                          // Enforce max 50000
                          if (price > 200) price = 200;

                          updateLineItem1(item.id, "quantity", price);
                        }}
                      />
                    </div>
                    <div>
                      <label>Unit Price</label>
                      <input
                        type="text"
                        value={`$ ${item.unitPrice}`}
                        onChange={(e) => {
                          // Extract only numbers + dot
                          let value = e.target.value.replace(/[^0-9.]/g, "");

                          // Convert to number
                          let price = parseFloat(value) || 0;

                          // Enforce max 50000
                          if (price > 50000) price = 50000;

                          updateLineItem1(item.id, "unitPrice", price);
                        }}
                      />
                    </div>
                    <div>
                      <label>Line Total</label>
                      <input
                        type="text"
                        value={`$${(item.quantity * item.unitPrice).toFixed(2)}`}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="add-more-section">
              <button className="add-more-btn" onClick={addLineItem1}>
                <span className="plus-icon">+</span> Add More
              </button>
            </div>
            <div className="pricing-summary">
              <h4>Pricing Summary</h4>

              <div className="summary-row">
                <span className="label">Sub Total:</span>
                <span className="value">${subTotal1.toFixed(2)}</span>
              </div>

              <div className="summary-row discount-row">
                <span className="label">Discount (%):</span>
                <div className="discount-input-wrapper">
                  <input
                    type="number"
                    step="0.01"
                    value={discount1 === 0 ? '' : discount1}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value === '') {
                        setDiscount1(0);
                        return;
                      }
                      if (value.includes('.')) {
                        const [intPart, decPart] = value.split('.');
                        value = intPart + '.' + decPart.slice(0, 2);
                      }
                      setDiscount1(Math.min(parseFloat(value) || 0, 100));
                    }}
                    className="discount-input"
                    max="100"
                    min="0"
                  />
                  <span className="percent-symbol">%</span>
                </div>
                <span className="value discount-value">
                  -${discountAmount1.toFixed(2)}
                </span>
              </div>



              <div className="summary-row discount-row">
                <span className="label">Tax (%):</span>
                <div className="discount-input-wrapper">
                  <input
                    type="number"
                    step="0.01"
                    value={tax1 === 0 ? '' : tax1}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value === '') {
                        setTax1(0);
                        return;
                      }
                      if (value.includes('.')) {
                        const [intPart, decPart] = value.split('.');
                        value = intPart + '.' + decPart.slice(0, 2);
                      }
                      setTax1(Math.min(parseFloat(value) || 0, 100));
                    }}
                    className="discount-input"
                    max="100"
                    min="0"
                  />
                  <span className="percent-symbol">%</span>
                </div>
                <span className="value tax-value">
                  +${tax1.toFixed(2)}
                </span>
              </div>

              <div className="summary-row final-row">
                <span className="label">Final Total:</span>
                <span className="value final-value">
                  ${finalTotal1.toFixed(2)}
                </span>
              </div>
            </div>

            {/* Additional Details Section */}
            <div className="additional-details">
              <h4>Additional Details</h4>

              {/* Customer Message */}
              <div className="form-group">
                <label>Customer Message</label>
                <textarea
                  className="customer-message"
                  value={customerMessage1}
                  onChange={(e) => setCustomerMessage1(e.target.value)}
                  rows="4"
                />
              </div>

              {/* Required Deposit and Bid Expiry */}
              <div className="two-column">
                <div className="form-group">
                  <label>Required Deposit</label>
                  <input
                    type="text"
                    value={`$ ${requiredDeposit1}`}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      setRequiredDeposit1(parseInt(value) || 0);
                    }}
                  />
                </div>

              </div>

              {/* Financing */}
              <div className="form-group">
                <label>Financing (optional)</label>
                <input
                  type="text"
                  value={`$${financing1}/month`}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    setFinancing1(parseInt(value) || 0);
                  }}
                />
              </div>

              {/* Attachments */}
              <div className="form-group attachments">
                <label>Attachments</label>
                <p className="helper-text">
                  Upload documents, images or PDFs to support your bid.
                </p>

                <div
                  className="upload-area"
                  onClick={() => document.getElementById("file-upload").click()}
                >
                  <img src={download} alt="upload icon" className="upload-icon" />
                  <p>Drop files here or click to upload</p>
                  <input
                    type="file"
                    multiple
                    accept="image/*,.pdf"
                    onChange={handleFileUpload1}
                    style={{ display: "none" }}
                    id="file-upload"
                  />
                  <button
                    type="button"
                    className="choose-files-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      document.getElementById("file-upload").click();
                    }}
                  >
                    Choose Files
                  </button>
                </div>

                {uploadedFiles1.length > 0 && (
                  <div className="uploaded-files">
                    {uploadedFiles1.map((file, index) => (
                      <div className="file-preview" key={index}>
                        {/* If image, show thumbnail; else show file name */}
                        {file.type.startsWith("image/") ? (
                          <img
                            src={URL.createObjectURL(file)}
                            alt={file.name}
                            className="file-thumb"
                          />
                        ) : (
                          <div className="file-name">{file.name}</div>
                        )}

                        <button
                          type="button"
                          className="remove-btn"
                          onClick={() => handleRemoveFile1(index)}
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Price Type Selection */}
            <div className="price-type-selection mb-3">
              <h4>Select one of the following:</h4>

              <div className="radio-group">

                <label className="radio-option">
                  <input
                    type="radio"
                    name="priceType"
                    value="estimated"
                    checked={priceType1 === "estimated"}
                    onChange={(e) => setPriceType1(e.target.value)}
                  />
                  <FaCalculator className="price-icon calculator-icon" />
                  <span>Estimated Price</span>
                  <FaInfoCircle className="info-icon" />
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="priceType"
                    value="guaranteed"
                    checked={priceType1 === "guaranteed"}
                    onChange={(e) => setPriceType1(e.target.value)}
                  />
                  <FiShield className="price-icon shield-icon" />
                  <span>Guaranteed Price</span>
                  <FaInfoCircle className="info-icon" />
                </label>


              </div>
            </div>

          </>
        )
      }

      {/* Option Best */}
      {/* Line Items */}
      {
        selectedIndex === 2 && (
          <>
            <div className="pd-line-items">
              <h6>Products/service</h6>
              {lineItems2.map((item, index) => (
                <div className="line-item" key={item.id}>
                  <div className="d-flex justify-content-between align-items-center">
                    <h5>Line Item {index + 1}</h5>
                    {index > 0 && (
                      <FaTrash
                        className="delete-icon"
                        onClick={() => deleteLineItem2(item.id)}
                      />
                    )}
                  </div>

                  <label>Product/service</label>
                  <input
                    type="text"
                    value={item.product}
                    onChange={(e) =>
                      updateLineItem2(item.id, "product", e.target.value)
                    }
                  />

                  <label>Description</label>
                  <textarea
                    type="text"
                    value={item.description}
                    onChange={(e) =>
                      updateLineItem2(item.id, "description", e.target.value)
                    }
                  />

                  <div className="line-pricing">
                    <div>
                      <label>Quantity</label>
                      <input
                        type="text"
                        value={item.quantity}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9.]/g, "");
                          // Convert to number
                          let price = parseFloat(value) || 0;

                          // Enforce max 50000
                          if (price > 200) price = 200;

                          updateLineItem2(item.id, "quantity", price);
                        }}
                      />
                    </div>
                    <div>
                      <label>Unit Price</label>
                      <input
                        type="text"
                        value={`$ ${item.unitPrice}`}
                        onChange={(e) => {
                          // Extract only numbers + dot
                          let value = e.target.value.replace(/[^0-9.]/g, "");

                          // Convert to number
                          let price = parseFloat(value) || 0;

                          // Enforce max 50000
                          if (price > 50000) price = 50000;

                          updateLineItem2(item.id, "unitPrice", price);
                        }}
                      />
                    </div>
                    <div>
                      <label>Line Total</label>
                      <input
                        type="text"
                        value={`$${(item.quantity * item.unitPrice).toFixed(2)}`}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="add-more-section">
              <button className="add-more-btn" onClick={addLineItem2}>
                <span className="plus-icon">+</span> Add More
              </button>
            </div>
            <div className="pricing-summary">
              <h4>Pricing Summary</h4>

              <div className="summary-row">
                <span className="label">Sub Total:</span>
                <span className="value">${subTotal2.toFixed(2)}</span>
              </div>

              <div className="summary-row discount-row">
                <span className="label">Discount (%):</span>
                <div className="discount-input-wrapper">
                  <input
                    type="number"
                    step="0.01"
                    value={discount2 === 0 ? '' : discount2}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value === '') {
                        setDiscount2(0);
                        return;
                      }
                      if (value.includes('.')) {
                        const [intPart, decPart] = value.split('.');
                        value = intPart + '.' + decPart.slice(0, 2);
                      }
                      setDiscount2(Math.min(parseFloat(value) || 0, 100));
                    }}
                    className="discount-input"
                    max="100"
                    min="0"
                  />
                  <span className="percent-symbol">%</span>
                </div>
                <span className="value discount-value">
                  -${discountAmount2.toFixed(2)}
                </span>
              </div>

              <div className="summary-row discount-row">
                <span className="label">Tax (%):</span>
                <div className="discount-input-wrapper">
                  <input
                    type="number"
                    step="0.01"
                    value={tax2 === 0 ? '' : tax2}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value === '') {
                        setTax2(0);
                        return;
                      }
                      if (value.includes('.')) {
                        const [intPart, decPart] = value.split('.');
                        value = intPart + '.' + decPart.slice(0, 2);
                      }
                      setTax2(Math.min(parseFloat(value) || 0, 100));
                    }}
                    className="discount-input"
                    max="100"
                    min="0"
                  />
                  <span className="percent-symbol">%</span>
                </div>
                <span className="value tax-value">
                  +${tax2.toFixed(2)}
                </span>
              </div>

              <div className="summary-row final-row">
                <span className="label">Final Total:</span>
                <span className="value final-value">
                  ${finalTotal2.toFixed(2)}
                </span>
              </div>
            </div>

            {/* Additional Details Section */}
            <div className="additional-details">
              <h4>Additional Details</h4>

              {/* Customer Message */}
              <div className="form-group">
                <label>Customer Message</label>
                <textarea
                  className="customer-message"
                  value={customerMessage2}
                  onChange={(e) => setCustomerMessage2(e.target.value)}
                  rows="4"
                />
              </div>

              {/* Required Deposit and Bid Expiry */}
              <div className="two-column">
                <div className="form-group">
                  <label>Required Deposit</label>
                  <input
                    type="text"
                    value={`$ ${requiredDeposit2}`}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      setRequiredDeposit2(parseInt(value) || 0);
                    }}
                  />
                </div>

              </div>

              {/* Financing */}
              <div className="form-group">
                <label>Financing (optional)</label>
                <input
                  type="text"
                  value={`$${financing2}/month`}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    setFinancing2(parseInt(value) || 0);
                  }}
                />
              </div>

              {/* Attachments */}
              <div className="form-group attachments">
                <label>Attachments</label>
                <p className="helper-text">
                  Upload documents, images or PDFs to support your bid.
                </p>

                <div
                  className="upload-area"
                  onClick={() => document.getElementById("file-upload").click()}
                >
                  <img src={download} alt="upload icon" className="upload-icon" />
                  <p>Drop files here or click to upload</p>
                  <input
                    type="file"
                    multiple
                    accept="image/*,.pdf"
                    onChange={handleFileUpload2}
                    style={{ display: "none" }}
                    id="file-upload"
                  />
                  <button
                    type="button"
                    className="choose-files-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      document.getElementById("file-upload").click();
                    }}
                  >
                    Choose Files
                  </button>
                </div>

                {uploadedFiles2.length > 0 && (
                  <div className="uploaded-files">
                    {uploadedFiles2.map((file, index) => (
                      <div className="file-preview" key={index}>
                        {/* If image, show thumbnail; else show file name */}
                        {file.type.startsWith("image/") ? (
                          <img
                            src={URL.createObjectURL(file)}
                            alt={file.name}
                            className="file-thumb"
                          />
                        ) : (
                          <div className="file-name">{file.name}</div>
                        )}

                        <button
                          type="button"
                          className="remove-btn"
                          onClick={() => handleRemoveFile2(index)}
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Price Type Selection */}
            <div className="price-type-selection mb-3">
              <h4>Select one of the following:</h4>

              <div className="radio-group">

                <label className="radio-option">
                  <input
                    type="radio"
                    name="priceType2"
                    value="estimated"
                    checked={priceType2 === "estimated"}
                    onChange={(e) => setPriceType2(e.target.value)}
                  />
                  <FaCalculator className="price-icon calculator-icon" />
                  <span>Estimated Price</span>
                  <FaInfoCircle className="info-icon" />
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="priceType2"
                    value="guaranteed"
                    checked={priceType2 === "guaranteed"}
                    onChange={(e) => setPriceType2(e.target.value)}
                  />
                  <FiShield className="price-icon shield-icon" />
                  <span>Guaranteed Price</span>
                  <FaInfoCircle className="info-icon" />
                </label>


              </div>
            </div>

          </>
        )
      }


      {/* <button className="submit-bid-btn" onClick={handleSubmitBid}>
        Submit Bid
      </button> */}


      {/* <div className="form-group">
        <label>Bid Expiry</label>
        <input
          type="text"
          value={bidExpiry}
          onChange={(e) => setBidExpiry(e.target.value)}
        />
      </div> */}



      <div className="bid-container">
        <div className="boost-amount">
          <h2>Your Boost Amount</h2>
          <div className="rank-table">
            <table>
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Bid</th>
                  <th>Now</th>
                </tr>
              </thead>
              <tbody>
                {boostBidsData.length > 0 &&
                  boostBidsData.map((row, index) => (
                    <tr key={index}>
                      <td>
                        {index < 3 && (
                          <img
                            src={rankImages[index]}
                            alt={`${index + 1} place`}
                            className="me-1"
                          />
                        )}
                        {row.rank}
                      </td>
                      <td className="bid_style">{row.amount} Credits</td>
                      <td>
                        {row.createdAt !== 1 ? (
                          timeAgo(row.createdAt) || ""
                        ) : (
                          <button onClick={() => handleRemoveBoostBid(index)}>
                            X
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="your-bid">
          <h3>Your Bid</h3>
          {boostBidsData.length > 0 && (
            <p>
              Bid {boostBidsData[0].amount + 1} credits or higher to be ranked
              in 1st place.
            </p>
          )}
          {boostBidsData.length === 0 && (
            <p>Bid 1 credits or higher to be ranked in 1st place.</p>
          )}
          <div className="bid-controller">
            <button onClick={handleDecrease}>-</button>
            <span>{bid}</span>
            <button onClick={handleIncrease}>+</button>
          </div>
          <div className="boost-bid-container">
            <div className="boost-bid">
              <button className="boost-btn">
                <img src={BoostYourBid} alt="Boost Your Bid" />
              </button>
              <div>
                <span> Boost Your Bid</span>
                <p className="boost-description text-start">
                  Stand out from the increase your chances of winning
                </p>
              </div>
            </div>
            <button className="boost-now-btn" onClick={() => handleBoostBid()}>
              <img
                src={boostBtn}
                alt="Boost"
                style={{ margin: "0 5px 1px 0" }}
              />
              Boost
            </button>
          </div>
        </div>

        <h4>Summary</h4>
        <div className="summary">
          <p>
            Bid to boost: <span>{boostBidPoints} credits</span>
          </p>
          <p>
            Required for proposal:{" "}
            <span>{jobData.isReadyToGo == 1 ? 10 : 5} credits</span>
          </p>
          <p className="total">
            Total:{" "}
            <span>
              {(jobData.isReadyToGo == 1 ? 10 : 5) + boostBidPoints} credits
            </span>
          </p>
        </div>

        <div className="actionss">
          <div className="d-flex gap-3">
            <button className="cancel-btn">Cancel</button>
            <button
              className="save-btn"
              onClick={() => handleSubmitBidWithDraft(1)}
            >
              Save as Draft
            </button>
          </div>
          <button className="submit-btn" onClick={() => handleSubmitBid(0)}>
            Submit Your Bid
          </button>
        </div>

        <div className="credits-required">
          <div className="info">
            <ErrorOutlineOutlinedIcon className="info-icon" />
            <h6>Credits Required</h6>
          </div>
          <p>
            Credits Required: Submit this bid will use{" "}
            {(jobData.isReadyToGo == 1 ? 10 : 5) + boostBidPoints} credits from
            your account. You currently have {credits} credits
          </p>
        </div>
      </div>
    </div >
  );
};

export default SubmitBidView;
